import { IPersonalInformation } from 'src/interfaces/personal-info';
import http from './http';

class PersonalInfoService {
  static patchPersonalInformation(data: Partial<IPersonalInformation>) {
    return http.patch(`/personal-informations/${data.id}`, data);
  }

  static getPersonalInformation() {
    return http.get('/personal-informations');
  }
}
export default PersonalInfoService;
